import axios from "axios";
import {
    initializeApp
} from "firebase/app";
import {
    getMessaging,
    getToken,
    onMessage
} from "firebase/messaging";
import { getCookie } from '../../../helpers/cookie';

import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
    apiKey: "AIzaSyC3UwrZbC-aAubjXdUoobGPTvB5wm8s3Y4",
    authDomain: "bharatpayroll-3b83c.firebaseapp.com",
    projectId: "bharatpayroll-3b83c",
    storageBucket: "bharatpayroll-3b83c.firebasestorage.app",
    messagingSenderId: "883345154154",
    appId: "1:883345154154:web:ce7732f0df19e6aa6daa13",
    measurementId: "G-22VQTZST32"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app);


onMessage(messaging, (payload) => {
  
    const notificationTitle = payload.notification.title;
    const notificationOptions = {
        body: payload.notification.body,
        icon: payload.notification.icon
    };

    new Notification(notificationTitle, notificationOptions);
});

function getBrowser() {
    const userAgent = window.navigator.userAgent;
    if (userAgent.indexOf("Chrome") !== -1) return "Chrome";
    if (userAgent.indexOf("Firefox") !== -1) return "Firefox";
    if (userAgent.indexOf("Safari") !== -1) return "Safari";
    if (userAgent.indexOf("Edge") !== -1) return "Edge";
    return "Unknown";
}

function getOS() {
    const userAgent = window.navigator.userAgent;
    if (userAgent.indexOf("Win") !== -1) return "Windows";
    if (userAgent.indexOf("Mac") !== -1) return "MacOS";
    if (userAgent.indexOf("Linux") !== -1) return "Linux";
    if (userAgent.indexOf("Android") !== -1) return "Android";
    if (userAgent.indexOf("iOS") !== -1) return "iOS";
    return "Unknown";
}
export const getDeviceTokenView = async () => {

    generateToken()
    // const browser = getBrowser();
    // const os = getOS();
    // var userinfo = JSON.parse(sessionStorage.getItem("user-info"));
    // let empCode = userinfo.data.employee.workDetails_EmployeeNumber;
    // const url = "/api/alerts/get-device-token-view/";
    // try {
    //     const response = await axios.get(url, {
    //         params: {
    //             emp_code: empCode,
    //             browser: browser,
    //             os: os
    //         },
    //         headers: {
    //         },
    //     });
    // } catch (error) {
    //     generateToken()
    //     console.error("Error:", error);
    // }
};

export const generateToken = async () => {
    const permission = await Notification.requestPermission();
    console.log(permission,'aijsioasjioasojs');
    
    if (permission === "granted") {
        const token = await getToken(messaging, {
            vapidKey: "BEnU56bihZ3G79nNgLfqLGyYOwf9yU81fNvWKgkLGLJp05E1sGW2KMsxKgh882a9uZi1tyXX-aysBPhDOfOxS5U",
        });
        
        if (token) {
            saveDeviceTokenToBackend(token);
        }
    }
   
};

function notifyMe() {
  
    alert("This browser does not support desktop notification");
  
}
    
const saveDeviceTokenToBackend = (token) => {
    const browser = getBrowser();
    const os = getOS();
    const UserInfo = JSON.parse(getCookie('user_info') || '{}');
    const token1 = getCookie('access_token')
    const userinfo = JSON.parse(sessionStorage.getItem("user-info"));
    // const empCode = UserInfo.data.employee.workDetails_EmployeeNumber;
    // const companyId = UserInfo.data.employee.company;
    // const token1 = userinfo.token.access;
    const empCode = UserInfo.employee.id;
    const companyId = UserInfo.id

    axios.post(
        `${process.env.REACT_APP_Company_Contact}/company/save-device-token-view/`,
        {
            // device_token: token,
            emp_code: empCode,
            // device_type: "webapp",
            emp_company: companyId,
            // browser: browser,
            // os: os,
        },

        // {
        //     "emp_code": "VAI-25",
        //     "device_token": "659909998",
        //     "device_type": "mobileapp",
        //     "unique_mobile_id": "gfvyugyugvyugb"
        // }
        {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token1}`,
            }
        }
    ).then(response => {
        
    }).catch(error => {
        console.error(error);
    });
};